export default {
  install: Vue => {
    Vue.prototype.$filterHtml = function (text) {
        text = text?text:''
        text = text.replace(/\u200b/g, ""); // （零宽空格）
        text = text.replace(/(?=\S)<br\s*\/?>/gi, '');//br
        text = text.replace(/<p>(.*?)<\/p>/g, (match, content) => {
          return `${content}\n`; // 保留内容并在其后追加换行符
        });
        text = text.replace(/<[^>]*>?/gm, '');// 去除 <>
        // console.log('remove html tag br', noHtmlString)
        return text;
    };

    Vue.prototype.$countWordNumber = function (str) {
        let text = str?str.replace(/\\n/g, '\n').replace(/\n/g, ''):"";
        return text.length
    };

    const errorMsg = '抱歉，章纲格式有误，章节序号必须为纯数字且单独一行，例如01，并且每个章节序号的数字要连续递增01>02>03'

    Vue.prototype.$validateTitle = function (content) {
        content = this.$filterHtml(content)
        const lines = content.split('\n');
        let prevChapterNumber = -1; // 用于记录上一个章节序号
        let hasContent = false; // 用于检查是否有章节内容

        for (let i = 0; i < lines.length; i++) {
            let line = lines[i].trim(); // 清除行首和行尾的半角空格
            line = line.replace(/\u200b/g, ""); // （零宽空格）
            line = line.replace(/^[\u3000\u0020]+|[\u3000\u0020]+$/g, ''); // 清除全角和半角空格
            // console.log(`line： ${line}`);
            // 检查是否是章节序号行
            if (/^\d+$/.test(line)) {
                console.log(`章纲序号：`, line);
                const currentChapterNumber = parseInt(line, 10);
                console.log(`章纲序号 2：`, line);
                // 检查章节序号是否递增
                if (currentChapterNumber <= prevChapterNumber) {
                  // this.$message.error(`错误：章节序号 ${currentChapterNumber} 不是递增的。`);
                  this.$message.error(errorMsg);
                  return false;
                }
                // 检查下一行是否有内容（章节细纲）
                if (i + 1 >= lines.length || lines[i + 1].trim() === '') {
                    // this.$message.error(`错误：章节 ${currentChapterNumber} 没有内容。`);
                    this.$message.error(errorMsg);
                    return false;
                }
                prevChapterNumber = currentChapterNumber;
                hasContent = true;
            }
        }
        // 检查是否有至少一个章节
        if (!hasContent) {
          // this.$message.error(`错误：章纲必须包含至少一个章节。`);
          this.$message.error(errorMsg);
          return false;
        }
        console.log(`通过：校验成功！`);
        return true;
    };

    Vue.prototype.$parseContent = function (text) {
       const storyOutlinesPrue = []
       if(!this.$validateTitle(text)){
         return storyOutlinesPrue;
       }
       text = this.$filterHtml(text)
       text = text + '\n 9527'
       const regex = /^(?:\s*(\d+)\s*(?:\n(?!\s*\d+\s*$).*)*)(?=(\n\s*\d+\s*$)|\Z)/gm;
       let matches;
       const outlineNumber = [];

       // 使用循环来处理所有匹配的项
       while ((matches = regex.exec(text)) !== null) {
         console.log(`matches:`, matches);
         const number = matches[1];
         // matches[0] 是整个匹配的字符串，包括数字和文本
         const groupWithNumber = matches[0];
         // 提取文本内容，去除数字行
         // const texts = groupWithNumber.split('\n').slice(1); // 从第二行开始，因为第一行是数字
         const texts = groupWithNumber.replace(number, '').trim(); // 从第二行开始，因为第一行是数字
          outlineNumber.push(parseInt(number, 10))
          // 将数字和文本内容添加到结果数组
          storyOutlinesPrue.push(texts);
       }
       // console.log(`通过:`, storyOutlinesPrue);
       return storyOutlinesPrue
    };

    Vue.prototype.$treeForeach = function (tree, func) {
      tree.forEach(data => {
        func(data)
        data.children && this.$treeForeach(data.children, func) // 遍历子树
      })
    };

    Vue.prototype.$buildTree = function (nodes, parentId, depth){
      let tree = []
      for (var i = 0, length = nodes.length; i < length; i++) {
        let node = nodes[i];
        node.label = node.desc
        node.value = node.id
        let pid = node.parentId;
        if(parentId == pid){
          node.depth = depth
          let tempTree = this.$buildTree(nodes, node.id, depth+1);
          if(!tempTree || tempTree.length == 0) {
            node.children = null;
          } else{
            node.children = tempTree;
          }

          tree.push(node)
        }
      }
      return tree
    };

    Vue.prototype.$treeToList = function (nodes){
      let tree = []
      let depthInit = nodes[0].depth
      this.$treeForeach(nodes, node => {
        node.depth = node.depth - depthInit
        tree.push(node)
      })
      return tree
    };
    // 处理作品条件
    Vue.prototype.$handleChangeArticleTypeId = function (value, story) {
      story.articleTypeId = value[value.length - 1];
      console.log('$handleChangeArticleTypeId', value, story.articleTypeId);
    };
    Vue.prototype.$handleChangeArticleStyleId = function (value, story) {
      story.articleStyleId = value[value.length - 1];
      console.log('$handleChangeArticleStyleId', value, story.articleStyleId);
    };
    Vue.prototype.$handleChangeArticleAgeId = function (value, story) {
      story.articleAgeId = value[value.length - 1];
      console.log('$handleChangeArticleAgeId', value, story.articleAgeId);
    };
    Vue.prototype.$isTouchDevice = function () {
      let flag = (
        'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof DocumentTouch) ||
        navigator.maxTouchPoints > 0 ||
        window.matchMedia("(pointer: coarse)").matches
      );
      // console.log(flag ? "触屏设备" : "非触屏设备");
      return flag
    };
    Vue.prototype.$isMobile = function () {
      let match = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if(!match){
        return false
      }else{
        return true
      }
    };

    Vue.prototype.$detectEnvironment = function () {
      // 只有这些明确的条件才会被认为是桌面应用
        const definiteDesktopConditions = [
          // Electron 的明确标志
          () => typeof process !== 'undefined' && process.versions?.electron,

          // NW.js 的明确标志
          () => typeof nw !== 'undefined',
          () => navigator.userAgent.includes('NW.js/'),
          () => navigator.userAgent.includes('node-webkit'),

          // Tauri 的明确标志
          () => window.__TAURI__,

          // 其他明确的桌面应用标志
          () => navigator.userAgent.includes('Electron/'),
          () => navigator.userAgent.includes('desktop-app/')
        ];

        // 检查所有明确条件
        for (const condition of definiteDesktopConditions) {
          try {
            if (condition()) {
              return 'desktop';
            }
          } catch (e) {
            // 忽略错误，继续检查下一个条件
          }
        }

        // 如果没有明确的桌面应用特征，就是浏览器
        return 'browser';
      };

      Vue.prototype.$isLastDigitOdd = function (str) {

        // 使用正则表达式匹配字符串末尾的数字
        try {
          if(1==1){
            return true
          }
          const lastDigitMatch = str.match(/\d(?=\D*$)/);

          // 如果没有找到数字，返回 false 或根据需求处理
          if (!lastDigitMatch) {
            return false; // 或者 throw new Error('字符串中没有数字')
          }

          // 获取最后一个数字并转换为整数
          const lastDigit = parseInt(lastDigitMatch[0], 10);

          // 检查是否为奇数
          return lastDigit % 2 !== 0;
        } catch (error) {
          return false;
        }

      };

      Vue.prototype.$unicodeToString = function (unicodeStr) {
        // 使用正则表达式替换并解析
        return unicodeStr.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
          // 将十六进制值转换为 Unicode 字符
          return String.fromCharCode(parseInt(hex, 16));
        });
      };
  }
}
